import { Wrapper } from './Styled'

export default function Free() {
  return <Wrapper />
}
